<script>
    import { createEventDispatcher } from "svelte/internal";
    import ModalGenerico from "../ModalGenerico.svelte";
    import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
    import * as Fx from '../../globals/Fx.js'

    export let show = true;
    export let data = null;

    let sus_nombre
    let sus_nit
    let sus_id_contrato
    let inputValorPagado = 0
    let textAnotaciones = ""
    let showSave = false
    let showSaveAnotaciones = false
    let rowSelected = null
    let idSelected = null
    let idxSelected = null
    let rows
    let totalCsmoEnergia = 0
    let totalImporteLiquidado = 0
    let totalValorRecaudado = 0
    let TotalSaldo = 0
    let link
    $: console.log("Modal Recaudo: ",data)
    $: inputValorPagado && inputValorPagado.focus()
    $: sus_nombre = data ? data[0].sus_nombre : null
    $: sus_nit = data ? data[0].sus_nit : null
    $: sus_id_contrato = data ? data[0].sus_id_contrato : null
    $: {
        totalCsmoEnergia = 0
        totalImporteLiquidado = 0
        totalValorRecaudado = 0
        TotalSaldo = 0
        data && data.map( item => {
            totalCsmoEnergia += item.liq_csmo_energia
            totalImporteLiquidado += item.liq_importe_liquidado
            totalValorRecaudado += item.liq_valor_pagado
            TotalSaldo += item.liq_saldo
        })
    }

    const dispatch = createEventDispatcher();


    const _close = () => {
        dispatch("close")        
    }

    const _toggleSelect = async (id, row, idx) => {
        if ((showSave || showSaveAnotaciones) && idSelected !== id) {
            const opc = confirm("Atención! No has guardado los cambios. ¿Deseas descartarlos?")
            if (!opc) return
            showSave = false
            showSaveAnotaciones = false
            idSelected = null;
        }else{
            idSelected = id;
            idxSelected = idx;
            rowSelected = row
        }
    };

    const settings = {
        sortable: true,
        rowsPerPage: 1000,
        columnFilter: false,
        labels: {
            search: "Buscar...", // search input placeholer
            filter: "Filtro", // filter inputs placeholder
            noRows: "Registro no encontrado",
            info: "Mostrando {start} a {end} de {rows} registros",
            previous: "Anterior",
            next: "Sguiente",
        },
        blocks: {
            searchInput: false,
            paginationButtons: false,
            paginationRowCount: false,
        }
    };

    const onKeyPress = async e => {
        if (e.charCode === 13) {
            if (showSave) {
                await _saveAll()
            }
            const idx = idxSelected === data.length - 1 ? idxSelected : idxSelected + 1
            _toggleSelect(`row-${data[idx].liq_periodo}`, data[idx], idx) 
        }
    };

    const _changeInput = () => {
        showSave = true
    }

    const _changeTextAnotaciones = () => {
        showSaveAnotaciones = true
    }

    async function handleFocus() {
        inputValorPagado.select();
    }

    const _saveAll = async () => {
        await _saveRecaudo()
        await _saveAnotaciones()
        showSave = false
        showSaveAnotaciones = false
        idSelected = null;
    }

    const _saveRecaudo = async  () => {
        let data2save = []
        data2save.push({liq_id_contrato:rowSelected.sus_id_contrato,liq_valor_pagado:inputValorPagado.value})
        dispatch("saveRecaudo",{
            periodo: rowSelected.liq_periodo,
            data: data2save
        })
        
    }

    const _saveAnotaciones = async  () => {
        let data2save = []
        data2save.push({liq_id_contrato:rowSelected.sus_id_contrato,liq_anotaciones:textAnotaciones.value})
        dispatch("saveAnotaciones",{
            periodo: rowSelected.liq_periodo,
            data: data2save
        })
    }

    const _exportExcel = () => {
        let HTML = `<h2>.</h2><h1 align="center" style="text-align:center">${data[0].sus_nombre}</h1><h3 align="center" style="text-align:center">NIT: ${data[0].sus_nit}</h3><h3 align="center" style="text-align:center">Contrato ID: ${data[0].sus_id_contrato}</h3><h2></h2> <br>`
        
        HTML += `<tabla>
            <thead>
                <th style="color:red; background-color:#ddd" data-key="num">#</th>
                <th style="color:red; background-color:#ddd" data-key="liq_periodo">Periodo</th>
                <th style="color:red; background-color:#ddd" class="text-end" data-key="liq_cmso_energia">Csmo Energía</th>
                <th style="color:red; background-color:#ddd" class="text-end" data-key="liq_importe_liquidado">Importe Liquidado</th>
                <th style="color:red; background-color:#ddd" class="text-end" data-key="liq_valor_pagado">Valor Recaudado</th>
                <th style="color:red; background-color:#ddd" class="text-end" data-key="liq_saldo">Saldo</th>
                <th style="color:red; background-color:#ddd" class="text-center" data-key="liq_anotaciones">Anotaciones</th>
            </thead>
            `
        data.forEach(element => {
            HTML += `<tr>`
            Object.keys(element).forEach((key) => {
                if ((`num|liq_periodo|liq_csmo_energia|liq_importe_liquidado|liq_valor_pagado|liq_saldo|liq_anotaciones`).indexOf(key) > -1) {
                    if ((`liq_csmo_energia|liq_importe_liquidado|liq_valor_pagado|liq_saldo`).indexOf(key) > -1){
                        HTML += `<td>${Fx.formatter.format(element[key]).cop()}</td>`
                    }else{
                        HTML += `<td>${element[key]}</td>`
                    }
                }
                // HTML += (`num|liq_periodo|liq_csmo_energia|liq_importe_liquidado|liq_valor_pagado|liq_saldo`).indexOf(key) > -1 ? `<td>${Fx.formatter.format(element[key]).cop()}</td>` : ``
            })
            HTML += `</td>`
        })
        HTML += `
            <tr>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" colspan="2" data-key="num"></td>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" class="text-end" data-key="liq_cmso_energia">${Fx.formatter.format(totalCsmoEnergia).cop()}</td>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" class="text-end" data-key="liq_importe_liquidado">${Fx.formatter.format(totalImporteLiquidado).cop()}</td>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" class="text-end" data-key="liq_valor_pagado">${Fx.formatter.format(totalValorRecaudado).cop()}</td>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" class="text-end" data-key="liq_saldo">${Fx.formatter.format(TotalSaldo).cop()}</td>
                <td style="color:#3f51b5;font-size: 16px; font-weight:bold" class="text-end" data-key="liq_saldo"></td>
            </tr>
            `
        HTML += `</table>`

        const xls = Fx.fnExcelReport(HTML, "Estado de cuenta")
        link.setAttribute("href", xls.data_type + ', ' + encodeURIComponent(Fx.myUTF8(xls.tab_text)));
        link.setAttribute("download",`Estado_de_cuenta_Cont_id_${data[0].sus_id_contrato}.xls`)
        
    }
    
</script>

<ModalGenerico {show} on:close={() => _close()}>
    <div class="d-flex flex-row justify-content-end p-2">
        <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()} title={"Exportar a Excel"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
              </svg>
        </a>
    </div>
    <header class="d-flex justify-content-center flex-column">
        <h1>{sus_nombre}</h1>
        <h3>Nit: {sus_nit}</h3>
        <h3>Contrato Id: {sus_id_contrato}</h3>
    </header>
    <section>
        {#if data}
            <Datatable {settings} data={data} bind:dataRows={rows} id={"tabla-recaudos-all-liqs"}>
                <thead>
                    <tr>
                        <th data-key="num">#</th>
                        <th data-key="liq_periodo">Periodo</th>
                        <th class="text-end" data-key="liq_cmso_energia">Csmo Energía</th>
                        <th class="text-end" data-key="liq_importe_liquidado">Importe Liquidado</th>
                        <th class="text-end" data-key="liq_valor_pagado">Valor Recaudado</th>
                        <th class="text-end" data-key="liq_saldo">Saldo</th>
                        <th class="text-start" data-key="liq_anotaciones">Anotaciones</th>
                    </tr>
                </thead>
                <tbody>
                    {#if rows}
                        {#each $rows as row, idx}
                            <tr
                                    class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}"
                                    class:active={`row-${row.liq_periodo}` ===  idSelected}
                                    class:line-row={ idx % 2 !== 0 ? true : false}
                                    on:click={() => _toggleSelect(`row-${row.liq_periodo}`, row, idx)}
                            >
                                    <td class="text-center" col="2">{row.num}</td>
                                    <td class="text-center">{row.liq_periodo}</td>
                                    <td><div class="text-end pi-end" style="width:100%">{Fx.formatter.format(row.liq_csmo_energia).cop()}</div></td>
                                    <td><div class="text-end pi-end" style="width:100%">{Fx.formatter.format(row.liq_importe_liquidado).cop()}</div></td>
                                    <td style="color:tomato;">
                                        {#if `row-${row.liq_periodo}` !==  idSelected}
                                            <div class="text-end pi-end" style="width:100%">{Fx.formatter.format(row.liq_valor_pagado).cop()}</div>
                                        {:else}
                                            <div class="d-flex flex-row justify-content-end align-items-center">
                                                <input 
                                                    class="inputCsmo" 
                                                    type="text" 
                                                    bind:this={inputValorPagado}
                                                    value={row.liq_valor_pagado} 
                                                    on:input={() => _changeInput()}
                                                    on:keypress={onKeyPress}
                                                    on:focus={async () => handleFocus()}
                                                />
                                                {#if showSave}
                                                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={async () => await _saveAll()} title={"Guardar" }>
                                                        <ion-icon name="save-sharp"></ion-icon>
                                                    </div>
                                                {:else}
                                                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:#0000001f; color:#34495e" title={"Editar recaudo" }>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                                        </svg>
                                                    </div>
                                                {/if}
                                            </div>
                                        {/if}
                                    </td>
                                    <td><div class="text-end pi-end" style="width:100%;">{Fx.formatter.format(row.liq_saldo).cop()}</div></td>
                                    <td style="color:tomato;">
                                        {#if `row-${row.liq_periodo}` !==  idSelected}
                                            <div style="width:100%; white-space: pre-line">{row.liq_anotaciones}</div>
                                        {:else}
                                            <div class="d-flex flex-row justify-content-end align-items-center">
                                                <textarea 
                                                    rows="2" 
                                                    class="textAnotaciones"
                                                    bind:this={textAnotaciones}
                                                    on:input={() => _changeTextAnotaciones()}
                                                >{row.liq_anotaciones}</textarea>
                                                {#if showSaveAnotaciones}
                                                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={async () => await _saveAll()} title={"Guardar" }>
                                                        <ion-icon name="save-sharp"></ion-icon>
                                                    </div>
                                                {:else}
                                                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:#0000001f; color:#34495e" title={"Editar Anotaciones" }>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                                        </svg>
                                                    </div>
                                                {/if}
                                            </div>
                                        {/if}
                                    </td>
                            </tr>
                        {/each}
                    {/if}
                </tbody>
                <tfoot>
                    <tr>
                        <th align="center" class="" colspan=2 ></th>
                        <th class="text-end ">{Fx.formatter.format(totalCsmoEnergia).cop()}</th>
                        <th class="text-end ">{Fx.formatter.format(totalImporteLiquidado).cop()}</th>
                        <th class="text-end ">{Fx.formatter.format(totalValorRecaudado).cop()}</th>
                        <th class="text-end ">{Fx.formatter.format(TotalSaldo).cop()}</th>
                    </tr>
                </tfoot>
            </Datatable>
        {/if}
    </section>
</ModalGenerico>

<style>
    header > * {
       align-self: center;
    }

    header {
        padding-block: 2em;
    }

    /* footer {
        position: fixed;
        display: flex;
        background-color: #fff;
        bottom: 0;
        width: 100%;
        padding: 10px;
    } */

    th {
        min-width: 10em;
        text-align: left;
    }

    td {
        text-align: left;
        white-space: nowrap;
        padding: 10px 10px;
    }

    tr {
        cursor: pointer;
        color: #3f51b5b5;
        font-size: 0.8em;
        transition: background-color 500ms;
    }

    tr.active {
        background-color: #14518d33 !important;
        /* color: #fff !important; */
    }

    tr.line-row {
        background-color: #efefef;
    }

    tr:hover {
        background-color: #14518d33 !important;
        color: #2c3e50 !important;
    }

    tfoot {
        border-top: 1px solid #ddd;
    }

    tfoot > tr > th {
        padding-block: 8px;
        font-size: 1.5em;
        padding-inline-end: 30px;
    }

    .inputCsmo {
        border-radius: 4px;
        border: 0;
        text-align: right;
        background-color: transparent;
        width: 100%;
        padding-inline-end: 20px;
        font-size: 1.1em;
        font-weight: bold;
    }

    .textAnotaciones {
        border-radius: 4px;
        border: 0;
        text-align:left;
        background-color: transparent;
        width: 100%;
        padding: 10px;
        margin-inline-end: 10px;
        font-size: 1.1em;
        font-weight: bold;
    }

    .textAnotaciones:hover, .textAnotaciones:focus {
        background-color: #ffffff40;
    }

    section {
        padding-inline: 60px;
        padding-block: 30px;
        height: 100%;
    }
    
    .pi-end {
        padding-inline-end: 20px;
    }

    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color : #fff;
        cursor: pointer;
        transition: all 250ms;
        margin-right: 10px;
    }

    .circular:hover {
        transform: scale(1.2);
    }

    /* width */
    ::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #0000001c; 
    }

    /* Handle */
    /* ::-webkit-scrollbar-thumb {
        background: #683ab7;;
    } */

    /* Handle on hover */
    /* ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    } */

</style>
